<template>
  <v-container>

    <Guide />
    
    <div id="page-heading" class="grey--text text-h5 text-sm-h4 text-md-h3 text-l-h2 text-xl-h2 mt-2">
      Upcoming tutorials
    </div>

    <v-row flex>
      <v-col cols="12" v-for="teachingSession in upcomingTeachingSessions" :key="teachingSession.id">
        <v-card outlined>
          <v-card-title>
            <span>{{ teachingSession.tutorial.subject.data.title }} > {{ teachingSession.tutorial.data.title }}</span>
            <v-spacer />
            <v-chip v-if="teachingSession.inProgress"
              color="green"
              text-color="white"
              class="text-uppercase"
            >
              In progress
            </v-chip>
            <v-chip v-if="teachingSession.inGracePeriod"
              color="red"
              text-color="white"
              class="text-uppercase"
            >
              Ending soon
            </v-chip>
            <v-btn depressed color="primary" class="ml-3" small router :to="{ name: 'TeachingSession', params: { id: teachingSession.id } }">
              Open
            </v-btn>
          </v-card-title>
          <v-card-subtitle>{{ teachingSession.data.startTime | date('EEE do MMM yyyy, HH:mm') }} - {{ teachingSession.data.endTime | date('HH:mm') }}</v-card-subtitle>
        </v-card>
      </v-col>

      <v-col cols="12" v-if="upcomingTeachingSessions.length == 0">
        <v-card outlined>
          <v-card-title>
            You have no upcoming tutorials
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import addMinutes from 'date-fns/addMinutes'
import Guide from '@/components/lecturer/Guide'

export default {
  name: "LecturerDashboard",
  components: { Guide },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapGetters({
      lecturer: 'lecturer'
    }),
    upcomingTeachingSessions() {
      let teachingSessions = []
      
      this.lecturer.subjects && this.lecturer.subjects.forEach(subject => {
        subject.tutorials && subject.tutorials.forEach(tutorial => {
          tutorial.teachingSessions && tutorial.teachingSessions.forEach(teachingSession => {

            // Check if the teachingSession ends in the future (it may already have started)
            // Allow 15 minutes grace period at end of the tutorial to handle any student requests
            const now = new Date()
            const endTimewithGrace = addMinutes(teachingSession.data.endTime, 15)
            if (endTimewithGrace > now && !teachingSession.data.isArchived) {
              // Check if the teachingSession is in progress or in the grace period
              teachingSession.inProgress = teachingSession.data.startTime < now && now < teachingSession.data.endTime
              teachingSession.inGracePeriod = teachingSession.data.endTime < now && endTimewithGrace > now
              teachingSessions.push(teachingSession)
            }
          })
        })
      })
      // Order by start time
      teachingSessions.sort((a, b) => a.data.startTime - b.data.startTime)

      return teachingSessions
    }
  },
  mounted() {
    this.$vuetify.goTo('#page-heading', {
      duration: 1000,
      easing: 'easeInOutCubic'
    })
  }
}
</script>